
 
export class storeTemplatesAction {
    static readonly type = '[templates] Templates';

    constructor(public payload: any) {
    }
}